import inputTypes from "../inputTypes";

const { POWER } = inputTypes;

export default {
  DEATH_ORB: {
    INTERNAL_ID: "SLOWORB",
    TYPE: POWER,
    NAME: "Death Orb",
  },
  TORNADO: {
    INTERNAL_ID: "TORNADO",
    TYPE: POWER,
    NAME: "Tornado",
  },
  KNIFE_DANCE: {
    INTERNAL_ID: "KNIVESCIRCLE",
    TYPE: POWER,
    NAME: "Knife Dance",
  },
  CORRUPTED_POWER: {
    INTERNAL_ID: "DAMAGEBUFF",
    TYPE: POWER,
    NAME: "Corrupted Power",
  },
  VAMPIRISM: {
    INTERNAL_ID: "LEECHBUFF",
    TYPE: POWER,
    NAME: "Vampirism",
  },
  TONIC: {
    INTERNAL_ID: "EXTRAHEAL",
    TYPE: POWER,
    NAME: "Tonic",
  },
  GRAPPLING_HOOK: {
    INTERNAL_ID: "HOOK",
    TYPE: POWER,
    NAME: "Grappling Hook",
  },
  PHASER: {
    INTERNAL_ID: "BACKBLINK",
    TYPE: POWER,
    NAME: "Phaser",
  },
  CORROSIVE_CLOUD: {
    INTERNAL_ID: "TOXICCLOUD",
    TYPE: POWER,
    NAME: "Corrosive Cloud",
  },
  LACERATING_AURA: {
    INTERNAL_ID: "DAMAGEAURA",
    TYPE: POWER,
    NAME: "Lacerating Aura",
  },
  WAVE_OF_DENIAL: {
    INTERNAL_ID: "SHOCKWAVE",
    TYPE: POWER,
    NAME: "Wave of Denial",
  },
  WINGS_OF_THE_CROW: {
    INTERNAL_ID: "WINGS",
    TYPE: POWER,
    NAME: "Wings of the Crow",
  },
  OWL: {
    INTERNAL_ID: "OWL",
    TYPE: POWER,
    NAME: "Great Owl of War",
  },
  OWL_UP: {
    INTERNAL_ID: "OWLUP",
    TYPE: POWER,
    NAME: "Great Owl of War (Angry)",
  },
  LIGHTSPEED: {
    INTERNAL_ID: "DASH",
    TYPE: POWER,
    NAME: "Lightspeed",
  },
  LIGHTSPEED_BACK: {
    INTERNAL_ID: "BACKDASH",
    TYPE: POWER,
    NAME: "Lightspeed (Back)",
  },
  GIANT_WHISTLE: {
    INTERNAL_ID: "GIANTWHISTLE",
    TYPE: POWER,
    NAME: "Giant Whistle",
  },
  TELLURIC_SHOCK: {
    INTERNAL_ID: "SEISMICSTOMP",
    TYPE: POWER,
    NAME: "Telluric Shock",
  },
  SYRINGE: {
    INTERNAL_ID: "COLLECTORSPIN",
    TYPE: POWER,
    NAME: "Collector's Syringe",
  },
  SMOKE_BOMB: {
    INTERNAL_ID: "SMOKEBOMB",
    TYPE: POWER,
    NAME: "Smoke Bomb",
  },
  MUSHROOM_BOI: {
    INTERNAL_ID: "SPAWNFRIENDLYHARDY",
    TYPE: POWER,
    NAME: "Mushroom Boi",
  },
  MUSHROOM_BOI_EXPLODE: {
    INTERNAL_ID: "EXPLODEFRIENDLYHARDY",
    TYPE: POWER,
    NAME: "Mushroom Boi (Explode)",
  },
  LIGHTNING_RODS: {
    INTERNAL_ID: "LIGHTNINGROD",
    TYPE: POWER,
    NAME: "Lightning Rods",
  },
  SCARECROWS_SICKLES: {
    INTERNAL_ID: "GARDENERSICKLES",
    TYPE: POWER,
    NAME: "Scarecrow's Sickles",
  },
  ICE_ARMOR: {
    INTERNAL_ID: "ICEARMOR",
    TYPE: POWER,
    NAME: "Ice Armor",
  },
  SERENADE: {
    INTERNAL_ID: "FLYINGSWORD",
    TYPE: POWER,
    NAME: "Serenade (Pet)",
  },
  COCOON: {
    INTERNAL_ID: "BUBBLESHIELDPOWER",
    TYPE: POWER,
    NAME: "Cocoon",
  },

  // -------------------------- EVERYONE IS HERE ---------------------------- //
  FACE_FLASK: {
    INTERNAL_ID: "FACEFLASK",
    TYPE: POWER,
    NAME: "Face Flask",
  },
  POLLO_POWER: {
    INTERNAL_ID: "POLLOPOWER",
    TYPE: POWER,
    NAME: "Pollo Power",
  },

  // ------------------------- QUEEN AND THE SEA ---------------------------- //
  LEGHUGGER: {
    INTERNAL_ID: "SPAWNLILSTAPHY",
    TYPE: POWER,
    NAME: "Leghugger",
  },
  ADULT_LEGHUGGER: {
    INTERNAL_ID: "SPAWNADULTLILSTAPHY",
    TYPE: POWER,
    NAME: "Leghugger (Evolved)",
  },

  // ------------------------------ BOSS RUSH ------------------------------- //
  TAUNT: {
    INTERNAL_ID: "TAUNT",
    TYPE: POWER,
    NAME: "Taunt",
  },

  // -------------------------- EVERYONE IS HERE 2 -------------------------- //
  DD_BARRICADE: {
    INTERNAL_ID: "DIVERSEDECKJUGGERNAUT",
    TYPE: POWER,
    NAME: "Diverse Deck - Barricade",
  },
  DD_CATALYST: {
    INTERNAL_ID: "DIVERSEDECKCATALYST",
    TYPE: POWER,
    NAME: "Diverse Deck - Catalyst",
  },
  DD_ELECTRO: {
    INTERNAL_ID: "DIVERSEDECKELECTRO",
    TYPE: POWER,
    NAME: "Diverse Deck - Electrodynamics",
  },
  DD_FORESIGHT: {
    INTERNAL_ID: "DIVERSEDECKWATCHER",
    TYPE: POWER,
    NAME: "Diverse Deck - Foresight",
  },

  // ------------------------ RETURN TO CASTLEVANIA ------------------------- //
  BOUNCINGSTONE: {
    INTERNAL_ID: "BOUNCINGSTONE",
    TYPE: POWER,
    NAME: "Rebound Stone",
  },
  BATVOLLEY: {
    INTERNAL_ID: "BATVOLLEY",
    TYPE: POWER,
    NAME: "Bat Volley",
  },
  SPAWNCAT: {
    INTERNAL_ID: "SPAWNCAT",
    TYPE: POWER,
    NAME: "Maria's Cat",
  },
  CATATTACK: {
    INTERNAL_ID: "CATATTACK",
    TYPE: POWER,
    NAME: "Maria's Cat (Attack)",
  },
};
